// @flow

export const CONVERT_TO_APPLICANT_MODAL = 'convertToApplicantModal';

export const SECTION_NAMES = {
  INCOME: 'income',
  PRIMARY_APPLICANT: 'primaryApplicant',
  UNITS_AND_PREFERENCES: 'unitsAndPreferences',
  FEES_AND_DEPOSITS: 'feesAndDeposits',
};

// Array order is the nav order; `name` doubles as the scroll-anchor key.
export const SECTIONS = [
  { name: SECTION_NAMES.INCOME },
  { name: SECTION_NAMES.PRIMARY_APPLICANT },
  { name: SECTION_NAMES.UNITS_AND_PREFERENCES },
  { name: SECTION_NAMES.FEES_AND_DEPOSITS },
];

// The first section is labelled Household on the conventional field set, and
// Income otherwise.
export const FIRST_SECTION_LABEL_KEYS = {
  HOUSEHOLD: 'household',
  INCOME: 'income',
};

// Which fields a property configuration asks for. WL is the waitlist set — an
// affordable property running a waitlist, the widest of the three; AFF drops
// the waitlist-only fields; CONV drops the affordable-compliance fields too.
// A mixed property moves between WL and CONV as programs are ticked while its
// waitlist runs, and stays on CONV while it is off.
export const FIELD_SETS = {
  WL: 'WL',
  AFF: 'AFF',
  CONV: 'CONV',
};

// Re-exported so this container's existing importers keep their import path
// while the Waitlist Summary card reads the constant from its shared home.
export { CONVENTIONAL_PROGRAM_NAME } from '../../utils/affordable';

// The same wizard serves four jobs. Convert creates an applicant from a
// prospect; add, edit and reinstate all act on an existing application and
// differ only in the endpoint they post to and the copy they show.
export const MODAL_MODES = {
  CONVERT: 'convert',
  ADD: 'add',
  EDIT: 'edit',
  REINSTATE: 'reinstate',
};

// Fees and deposits are quoted while an applicant is being created; there is
// nothing to quote against a record that already exists.
export const getSections = (
  mode: string = MODAL_MODES.CONVERT,
): Array<Object> =>
  mode === MODAL_MODES.CONVERT
    ? SECTIONS
    : SECTIONS.filter(({ name }) => name !== SECTION_NAMES.FEES_AND_DEPOSITS);
